"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.periodNameSchema = exports.PeriodName = void 0;
const zod_1 = require("zod");
var PeriodName;
(function (PeriodName) {
    // Annual period
    PeriodName["A"] = "A";
    // Quarter periods
    PeriodName["Q1"] = "Q1";
    PeriodName["Q2"] = "Q2";
    PeriodName["Q3"] = "Q3";
    PeriodName["Q4"] = "Q4";
    // Half year periods
    PeriodName["H1"] = "H1";
    PeriodName["H2"] = "H2";
    // Month periods
    PeriodName["M1"] = "M1";
    PeriodName["M2"] = "M2";
    PeriodName["M3"] = "M3";
    PeriodName["M4"] = "M4";
    PeriodName["M5"] = "M5";
    PeriodName["M6"] = "M6";
    PeriodName["M7"] = "M7";
    PeriodName["M8"] = "M8";
    PeriodName["M9"] = "M9";
    PeriodName["M10"] = "M10";
    PeriodName["M11"] = "M11";
    PeriodName["M12"] = "M12";
    // YTD periods (examples are when fiscal year ends in December)
    PeriodName["YTD1"] = "YTD1";
    PeriodName["YTD2"] = "YTD2";
    PeriodName["YTD3"] = "YTD3";
    PeriodName["YTD4"] = "YTD4";
    PeriodName["YTD5"] = "YTD5";
    PeriodName["YTD6"] = "YTD6";
    PeriodName["YTD7"] = "YTD7";
    PeriodName["YTD8"] = "YTD8";
    PeriodName["YTD9"] = "YTD9";
    PeriodName["YTD10"] = "YTD10";
    PeriodName["YTD11"] = "YTD11";
    PeriodName["YTD12"] = "YTD12";
})(PeriodName || (exports.PeriodName = PeriodName = {}));
exports.periodNameSchema = zod_1.z.enum(PeriodName);
